'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _assign2 = require('lodash/assign');
var _assign3 = _interopRequireDefault(_assign2);
var _isObject2 = require('lodash/isObject');
var _isObject3 = _interopRequireDefault(_isObject2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _linkClass = require('./linkClass');
var _linkClass2 = _interopRequireDefault(_linkClass);
var _renderNothing = require('./renderNothing');
var _renderNothing2 = _interopRequireDefault(_renderNothing);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * @see https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function WrappedComponent() {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var styles = void 0;
    var useProps = void 0;
    var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);
    if (props.styles || hasDefaultstyles) {
      useProps = Object.assign({}, props);
      if (props.styles) {
        styles = props.styles;
      } else {
        styles = defaultStyles;
      }
      Object.defineProperty(useProps, 'styles', {
        configurable: true,
        enumerable: false,
        value: styles,
        writable: false
      });
    } else {
      useProps = props;
      styles = {};
    }
    var renderResult = Component.apply(undefined, [useProps].concat(args));
    if (renderResult) {
      return (0, _linkClass2.default)(renderResult, styles, options);
    }
    return (0, _renderNothing2.default)(_react2.default.version);
  };
  (0, _assign3.default)(WrappedComponent, Component);
  return WrappedComponent;
}; /* eslint-disable react/prop-types */

module.exports = exports['default'];